import "./modal.scss";

import React from "react";

import { PropTypeShapes } from "../../types";

const ModalFooterRightGroup = props => <div className="rightGroup">{props.children}</div>;

ModalFooterRightGroup.propTypes = {
  children: PropTypeShapes.elementOrArray
};

export default ModalFooterRightGroup;
